import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '../../components/visibility';
import ClassDropdown from '@components/class-dropdown';
import Label from '@components/block-label';
import LinkControls from '@components/link';
import {
  FocusableIcon,
  FocusableIconSwitcher,
} from '@components/focusable-block-icon';
import { title } from './block.json';
import linkIcon from './icon';

import './editor.scss';
import { DEFAULT_CSS_CLASS } from '@constants';

const InspectorGeneral = ({ attributes, setAttributes }) => {
  const { blockVisibility, label } = attributes;

  return (
    <InspectorControlsGeneral>
      <Label {...{ label, setAttributes }} />
      <Visibility {...{ blockVisibility, setAttributes }} />
      <LinkControls {...{ attributes, setAttributes }} />
    </InspectorControlsGeneral>
  );
};

const InspectorAppearance = (props) => {
  const {
    attributes: { blockClassNames, enableFocusableIcon },
    setAttributes,
  } = props;

  return (
    <InspectorControlsAppearance>
      <ClassDropdown
        {...{
          blockClassNames,
          setAttributes,
          blockClassPrefix: DEFAULT_CSS_CLASS.LINK,
          initialOpen: true,
        }}
      />
      <FocusableIconSwitcher
        {...{
          enableFocusableIcon,
          setAttributes,
        }}
      />
    </InspectorControlsAppearance>
  );
};

const Edit = (props) => {
  const { attributes } = props;
  const { blockVisibility, blockClassNames, enableFocusableIcon } = attributes;
  const getDropDownClasses = blockClassNames
    ?.map((classes) => classes.value)
    .join(' ');

  const blockProps = useBlockProps({
    className: `${DEFAULT_CSS_CLASS.LINK} ${getDropDownClasses} ${
      blockVisibility !== true ? 'disable' : null
    }`,
  });

  const { children, ...innerBlocksProps } = useInnerBlocksProps(blockProps, {});

  return (
    <>
      <InspectorTabs>
        <InspectorGeneral {...props} />
        <InspectorAppearance {...props} />
      </InspectorTabs>
      <span {...innerBlocksProps}>
        {enableFocusableIcon && (
          <FocusableIcon {...{ title, icon: linkIcon }} />
        )}
        {children}
      </span>
    </>
  );
};

export default Edit;
